module.exports = __webpack_public_path__ + "img/windows1.5e866a0c.png";